import React from 'react'

export default function LoadingBox(props) {
    return (
        <div className="loading">
        <i className="fa fa-spinner fa-spin"></i> {props.Mensaje?props.Mensaje:'Buscando, por favor aguarde unos instantes...'} 
      </div>
    )
}
